import React from 'react';
import Panel from '../../../../components/outline/Panel';
import BaseForm from '../../../../components/form/BaseForm';
import { setDateFormat } from '../../../../lib/moment';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';

const CouponIssueHistoryDetailInfo = (props) => {
  const { couponIssueHistoryInfo } = props;
  const { couponIssueHistoryId, adminName, createDate, memo } = couponIssueHistoryInfo;

  return (
    <Panel className="coupon-issue-history-detail-info">
      <div className="panel-header">
        <div className="title">쿠폰 발급 내역 정보</div>
      </div>

      <div className="panel-body">
        {/* 발급 이력 id */}
        <BaseForm label="발급 이력 id" content={couponIssueHistoryId} />

        {/* 발급한 관리자 */}
        <BaseForm label="발급한 관리자" content={adminName} />

        {/* 쿠폰 발급 이력 생성일 */}
        <BaseForm label="쿠폰 발급 이력 생성일" content={setDateFormat(createDate, DATE_FORMAT.FULL_DASH_FORMAT)} />

        {/* 메모 */}
        <BaseForm label="메모" content={memo} />
      </div>
    </Panel>
  );
};

export default CouponIssueHistoryDetailInfo;
